export default __webpack_public_path__ + "static/python-programming-834923dc3ef056cf15bcb48fd9debbc8.webp";